// Smooth scroll to anchor links
$('a').click(function(e) {
    scrollToAnchor(this.href, e, 100);
});

function scrollToAnchor(href, event, offset) {
    if (href.length <= 1) {
        return;
    }

    var hashIndex = href.indexOf('#');

    if (hashIndex === -1) {
        return;
    }

    var currentPath = window.location.origin + window.location.pathname;
  /*   if (hashIndex > 0 && href.substring(0, hashIndex) !== currentPath) {
        return;
    } */

    var id = href.substring(hashIndex + 1);

    if (!id) {
        return;
    }

    var $el = $('#' + id);

    if ($el.length === 0){
        return;
    }

    $('html, body').animate({
        scrollTop: $el.offset().top - (offset || 0)
    }, 300);

    if (event) {
        event.preventDefault();
        //window.location.hash = id;
    }
}

window.scrollToAnchor = scrollToAnchor;

if (window.location.hash) {
    var target = window.location.hash,
    target = target.replace('#', '');
    window.location.hash = "";
    setTimeout(function () {
        $('html,body').animate({
            scrollTop: $("#" + target).offset().top - 80
        }, 300);
    }, 900)
}